export default __webpack_public_path__ + "assets/addressIcon.3c8bb08f.png";